import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { clientsApi } from '@modules/clients/entities/client/api';
import queryClient from '@app/queryClient';
import { useTranslation } from 'react-i18next';

const useAssociateCompanyClient = (companyId: string) => {
  const { t } = useTranslation();

  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['useAssociateCompanyClient'],
    mutationFn: (clientId: string) => clientsApi.associateCompanyClient(companyId, clientId),
    onSuccess: (_) => {
      queryClient.refetchQueries({ queryKey: ['clientsList'] });
      toast('info', { message: t('clients.addClient.clientAdded') });
    },
    onError: () => {
      toast('error', { message: t('clients.addClient.clientCreationFailed') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useAssociateCompanyClient;
